import cn from 'classnames';
import { prevented, noop } from '@utils/event';
import PLAN_TYPES from './constants';
import styles from '../serviceinfo.module.scss';

type LearnMoreProps = {
  onLearnMore: BaseAnyFunction;
};

type AnnualLabelProps = {
  showMonthly?: boolean;
  amount?: string;
  planAmount?: number;
  onLearnMore: BaseAnyFunction;
  planName: string;
  planPricingSplit: boolean;
  oldPrice: string;
  currentPrice: string;
};

type MonthlyLabelProps = {
  planAmount?: number;
  amount?: string;
  onLearnMore: BaseAnyFunction;
  planName: string;
  planPricingSplit: boolean;
  oldPrice: string;
  currentPrice: string;
};

type GetPlanLabelProps = {
  showPlanType: string;
  planValue: number;
  amount: string;
  onLearnMore: $FixMe;
  planAmount: number;
  planName: string;
  oldPrice: string;
  currentPrice: string;
  planPricingSplit: boolean;
};

type ServiceUpsellPriceProps = {
  oldPrice: string;
  currentPrice: string;
  classes?: string;
};

const LearnMore = ({ onLearnMore }: LearnMoreProps) => (
  <span className={styles.upsellAnnualSavings}>
    <a href="#" className={styles.upsellLearnMore} onClick={prevented(onLearnMore)}>
      Learn More
    </a>
  </span>
);

export const ServiceUpsellPrice = ({ oldPrice, currentPrice, classes }: ServiceUpsellPriceProps) => (
  <>
    <span className={cn('line-through paddingRight-tiny', classes)}>{oldPrice}</span>
    <span>{currentPrice}</span>
  </>
);

const AnnualLabel = ({ amount, planAmount, planName, planPricingSplit, oldPrice, currentPrice, onLearnMore = noop }: AnnualLabelProps) => {
  const planPrice = planPricingSplit ? <ServiceUpsellPrice oldPrice={oldPrice} currentPrice={currentPrice} /> : `$${planAmount}`;

  if (!planAmount) return null;

  return (
    <span className={cn('caption', styles.upsellLabel)}>
      <h6 className={styles.planInfo}>
        Join {planName} and Save {amount}
      </h6>
      <p className="caption n700">
        {' '}
        with {planPrice} Annual membership. <LearnMore onLearnMore={onLearnMore} />
      </p>
    </span>
  );
};

const MonthlyLabel = ({ planAmount, amount, onLearnMore, planName, planPricingSplit, oldPrice, currentPrice }: MonthlyLabelProps) => {
  const planPrice = planPricingSplit ? <ServiceUpsellPrice oldPrice={oldPrice} currentPrice={currentPrice} /> : `$${planAmount}`;

  if (!planAmount) return null;

  return (
    <span className={styles.upsellLabel}>
      <h6 className={styles.planInfo}>
        Join {planName} and Save {amount}
      </h6>
      <p className="caption n700">
        {' '}
        with {planPrice}/mo annual membership. <LearnMore onLearnMore={onLearnMore} />
      </p>
    </span>
  );
};

const getPlanLabel = ({ showPlanType, planValue, ...rest }: GetPlanLabelProps) => {
  const planType = {
    [PLAN_TYPES.ANNUAL]: <AnnualLabel {...(rest as AnnualLabelProps)} />,
    [PLAN_TYPES.MONTHLY]: <MonthlyLabel {...(rest as MonthlyLabelProps)} />,
  };

  return planType[showPlanType];
};

export default getPlanLabel;
